import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

const { TextArea } = Input;

class InlineGuidingTextEditor extends Component {
  handleChange = (e) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  }

  render() {
    const { value, placeholder, disabled } = this.props;

    return (
      <TextArea
        value={value}
        onChange={this.handleChange}
        placeholder={placeholder || 'Enter guiding text...'}
        rows={3}
        disabled={disabled}
        style={{
          backgroundColor: disabled ? '#f5f5f5' : '#fff',
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
        }}
      />
    );
  }
}

InlineGuidingTextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

InlineGuidingTextEditor.defaultProps = {
  value: '',
  placeholder: '',
  disabled: false,
};

export default InlineGuidingTextEditor;
